import React, { useCallback } from 'react';
import classNames from 'classnames';
import DayPicker from 'react-day-picker';
import { useMediaQuery } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import moment from 'moment';
import styles from './styles';
import { Labels } from '../../constants';
import 'react-day-picker/lib/style.css';
import './appointment-selector.scss';

import ValidationMessage from '../../../validation-message';
import TimeSelector from './components/time-selector';

import { makeStyles } from '@material-ui/core';
const useStyle = makeStyles({
  dayPickerContainer: {
    '& .DayPicker-Caption': {
      fontSize: '13px',
      color: '#12253F',
      paddingLeft: '17px'
    },
    '& .DayPicker': {
      width: '100%'
    },
    '& .DayPicker-Month': {
      width: '100%'
    }
  }
});

const AppointmentSelector = ({
  openDays,
  selectedDay,
  onMonthChange,
  onDayClick,
  dayPickerField,
  readOnly,
  forceRenderDatePicker,
  initialMonth,
  isOpenDaysLoading,
  isAppointmentDaysLoading
}) => {
  const modifiers = {
    highlighted: selectedDay,
    allDay: { daysOfWeek: [0, 1, 2, 3, 4, 5, 6] }
  };

  const disableDaysOfMonth = (day) => {
    return openDays.indexOf(moment(day).dayOfYear()) === -1;
  };

  const validationClass = classNames({
    'control-group error': !!dayPickerField.validationMessage
  });

  const readOnlyStyle = readOnly && styles.readOnly;
  const classes = useStyle();

  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');

  const isTablet = matches || isIpadLg;

  return (
    <div style={isTablet ? styles.displayColumn : styles.dateTimeContainer}>
      <div className="form-field-input-container" style={styles.inputContainer}>
        <div className="form-field-label primary appointment-booking-date-label">
          {`${Labels.AppointmentDate} *`}
          {isAppointmentDaysLoading && <div className="loader"></div>}
        </div>
        {forceRenderDatePicker && (
          <div
            style={{ ...styles.calendarContainer, ...readOnlyStyle }}
            className={`${validationClass} ${classes.dayPickerContainer}`}
          >
            <DayPicker
              selectedDays={selectedDay}
              initialMonth={initialMonth || selectedDay || new Date()}
              disabledDays={[
                {
                  before: moment().startOf('day').toDate()
                },
                disableDaysOfMonth
              ]}
              fromMonth={moment().startOf('day').toDate()}
              weekdayElement={<Weekday />}
              navbarElement={<Navbar isOpenDaysLoading={isOpenDaysLoading} />}
              onMonthChange={onMonthChange}
              onDayClick={onDayClick}
              modifiers={modifiers}
              modifiersStyles={styles.calendarStyles}
              containerProps={{ readOnly, id: dayPickerField.uuid }}
            />
            <ValidationMessage message={dayPickerField.validationMessage} />
          </div>
        )}
      </div>
    </div>
  );
};

AppointmentSelector.defaultProps = {
  openDays: [],
  timeSlots: [[], []],
  selectedDay: null,
  selectedTime: null,
  readOnly: false
};

const Weekday = ({ weekday, className, localeUtils, locale }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return (
    <div className={className} title={weekdayName} style={styles.weekDay}>
      {weekdayName.slice(0, 3)}
    </div>
  );
};

const Navbar = ({
  onPreviousClick,
  onNextClick,
  className,
  showPreviousButton,
  isOpenDaysLoading
}) => {
  const previousClick = useCallback(() => {
    onPreviousClick();
  }, []);

  const nextClick = useCallback(() => {
    onNextClick();
  }, []);

  let arrowBackStyle = styles.arrowBackButton;
  let mainDivStyle = styles.notDisabled;
  if (!showPreviousButton) {
    arrowBackStyle = styles.arrowBackDisabledStyle;
  }
  if (isOpenDaysLoading) {
    mainDivStyle = styles.disabled;
  }

  return (
    <div style={mainDivStyle}>
      <div className={className} style={styles.arrowButton}>
        <ArrowBackIosIcon onClick={previousClick} style={arrowBackStyle} />
        <ArrowForwardIosIcon
          onClick={nextClick}
          style={styles.arrowForwardButton}
        />
      </div>
    </div>
  );
};

export default AppointmentSelector;
